import { render, staticRenderFns } from "./PdfSlider.vue?vue&type=template&id=4fb6abf5&"
import script from "./PdfSlider.vue?vue&type=script&lang=js&"
export * from "./PdfSlider.vue?vue&type=script&lang=js&"
import style0 from "./PdfSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VSheet,VSlideGroup,VSlideItem})
